import { useLocation } from "react-router-dom";

interface IUseCurrentTabProps {
  orderedTabList: string[];
};

export function useCurrentTab({ orderedTabList }: IUseCurrentTabProps) {
  const { pathname } = useLocation();

    let index = 0;
    const lastTabIndex = orderedTabList.length - 1;

    for (const tab of orderedTabList) {
        if (index === lastTabIndex || pathname.toLowerCase().includes(tab.toLowerCase())) return tab;
        index++;
    }
};